import { CollectionEntity } from "@busy-human/gearbox";
import { Questions } from "../Questions/index.js";
export var Reports;
(function (Reports) {
    function ramReportDefaults() {
        return {
            ramScore: null,
            ramTotal: null,
            signedBy: null,
            signedAt: null,
            timeCreated: null,
            unit: null,
            unitId: null,
            incident: null,
            incidentNumber: null,
            ramOrder: null
        };
    }
    Reports.Relationships = {
        questions: ['questions', Questions.CollectionClass]
    };
    function OOSReportDefault() {
        return {
            unit: null,
            startTime: null,
            endTime: null,
            oosStatus: '',
            userId: null
        };
    }
    class CollectionClass extends CollectionEntity {
        relationships = Reports.Relationships;
        // relationships?: EntityRelationships;
        defaults() {
            return ramReportDefaults();
        }
    }
    Reports.CollectionClass = CollectionClass;
    // export const Reports = new CollectionClass({ path: "/Reports" });
    class OOSCollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return OOSReportDefault();
        }
    }
    Reports.OOSCollectionClass = OOSCollectionClass;
    // export const OOSReports = new OOSCollectionClass({ path: "/OOSReports" });
})(Reports || (Reports = {}));
//# sourceMappingURL=index.js.map